<template>
  <Progress v-bind="getBindValue" />
</template>

<script setup lang="ts">
  import { Progress, ProgressProps } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import type { CellProps } from '@mts/components/Table';

  defineOptions({
    name: 'BaseProgress',
    inheritAttrs: false,
  });

  interface BaseProgressProps extends Partial<CellProps>, Omit<ProgressProps, 'status'> {
    value?: unknown;
    status?: ProgressProps['status'] | 'error' | 'warn' | 'info' | 'cancel';
    getStatus?: (opt: Partial<CellProps>) => BaseProgressProps['status'];
  }
  const props = withDefaults(defineProps<BaseProgressProps>(), {
    showInfo: true,
    size: 'small',
  });

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    const { text, record, column, index, value, status, getStatus, ...restProps } = props;

    return {
      ...attrs,
      ...restProps,
      status: getStatus?.({ text, record, column, index }) || props.status,
      percent: parseFloat((value ?? text) as string),
    } as ProgressProps;
  });
</script>

<style lang="less">
  .ant-progress {
    .ant-progress-inner {
      background-color: #ebedf0;
    }

    &.ant-progress-small.ant-progress-line {
      font-size: 14px;

      .ant-progress-text .anticon {
        font-size: 16px;
      }
    }

    &.ant-progress-status-error .ant-progress-bg {
      background-color: #f50a0a;
    }

    &.ant-progress-status-warn .ant-progress-bg {
      background-color: #fdaf00;
    }

    &.ant-progress-status-info .ant-progress-bg {
      background-color: #37f;
    }

    &.ant-progress-status-cancel .ant-progress-bg {
      background-color: #7a8494;
    }
  }
</style>
